export enum ProductTypesEnum {
  Union = "union",
  FamilyUnion = "familyUnion",
  UnemploymentBenefits = "unemploymentBenefits",
  SalaryInsurance = "salaryInsurance",
}
